import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updatePerimeter } from '../../services/farmMapping/perimeter/updatePerimeter'
import { queryKeys } from './queryKeys'

type UpdatePerimeterVariables = Parameters<typeof updatePerimeter>[0]

export const useUpdatePerimeter = ({ farmId }: { farmId: string | undefined }) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (variables: UpdatePerimeterVariables) => updatePerimeter(variables),
    retry: 0,
    // This write runs inside the caller's processLoading wrapper, which already surfaces failures
    // through the loading modal — letting the global handler fire too would double-report.
    meta: { suppressGlobalError: true },
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.farm(farmId) }),
        queryClient.invalidateQueries({ queryKey: queryKeys.farms(), exact: true }),
      ]),
  })
}
